module.exports = __webpack_public_path__ + "img/cancun-letras.2cad3668.jpg";